import StatementTable from './StatementTable';
import { withI18n } from 'react-i18next';
export default withI18n()(StatementTable);
